import {ACCESS_TOKEN, V1_API_URL_PREFIX} from '../Constants';
import {request} from "./ApiUtils";

export function policies() {
    return request({
        url: V1_API_URL_PREFIX + "/policies",
        method: 'GET'
    });
}

export function saveOrUpdatePolicy(record) {
    return request({
        url: V1_API_URL_PREFIX + "/policies/update",
        method: 'POST',
        body: JSON.stringify(record)
    });
}

export function deletePolicy(record) {
    const headers = new Headers({
        'Content-Type': 'application/json',
    });

    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
    }

    const defaults = {headers: headers};
    let options = Object.assign({}, defaults, {
        url: V1_API_URL_PREFIX + "/policies/delete",
        method: 'DELETE',
        body: JSON.stringify(record)
    });

    return fetch(options.url, options)
        .then(response => {
            if (response.status !== 204) {
                return Promise.reject();
            }
            return Promise.resolve();
        });
}

export function deletePolicyFile(policyId) {
    const headers = new Headers({
        'Content-Type': 'application/json',
    });

    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
    }

    const defaults = {headers: headers};
    let options = Object.assign({}, defaults, {
        url: V1_API_URL_PREFIX + "/policies/file/" + policyId,
        method: 'DELETE',
    });

    return fetch(options.url, options)
        .then(response => {
            if (response.status !== 204) {
                return Promise.reject();
            }
            return Promise.resolve();
        });
}
